<template>
  <div class="profile-photo-circle">
    <div class="profile-photo" style="background-color:white">
      <div class="profile-photo relative" :style="`background-image: url(${profilePhoto});`">
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue';

export default {
  setup() {
    return {
      profilePhoto: ref('/espacepersonnel/img/nophoto.png')
    }
  }
};
</script>

<style scoped>
.profile-photo-circle {
  border-radius: 50%;
  border: 3px solid #00a6c6;
  position: relative;
}

.profile-photo {
  width: 90%;
  height: 90%;
  border-radius: 50%;
  position: absolute;
  background-size: cover;
  background-position: center center;
  left: 0;
  right: 0;
  bottom:0;
  top:0;
  margin:auto;
}

.profile-name {
  text-align: left;
}

.profile-user {
  background-color: white;
  border-bottom: 2px solid #00a6c6;
  height: 180px;
  min-height: 180px;
}
</style>
